import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { contactData } from '../mock';

export const Contact = () => {
  return (
    <section id="contact" className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="heading-1">{contactData.title}</h2>
          <div className="gold-line" style={{ margin: '24px auto' }} />
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>{contactData.subtitle}</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '60px' }}>
          <div>
            <h3 className="heading-3" style={{ marginBottom: '32px' }}>Get in touch</h3>
            
            <div style={{ marginBottom: '24px', display: 'flex', gap: '16px' }}>
              <div style={{ width: '48px', height: '48px', border: '1px solid var(--border-medium)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Mail size={20} color="var(--accent-gold)" />
              </div>
              <div>
                <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '4px' }}>Email</p>
                <a href={`mailto:${contactData.email}`} className="body-regular" style={{ color: 'var(--text-primary)', textDecoration: 'none' }}>{contactData.email}</a>
              </div>
            </div>

            <div style={{ marginBottom: '24px', display: 'flex', gap: '16px' }}>
              <div style={{ width: '48px', height: '48px', border: '1px solid var(--border-medium)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Phone size={20} color="var(--accent-gold)" />
              </div>
              <div>
                <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '4px' }}>Phone</p>
                <a href={`tel:${contactData.phone}`} className="body-regular" style={{ color: 'var(--text-primary)', textDecoration: 'none' }}>{contactData.phone}</a>
              </div>
            </div>

            <div style={{ marginBottom: '32px', display: 'flex', gap: '16px' }}>
              <div style={{ width: '48px', height: '48px', border: '1px solid var(--border-medium)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <MapPin size={20} color="var(--accent-gold)" />
              </div>
              <div>
                <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '4px' }}>Location</p>
                <p className="body-regular" style={{ color: 'var(--text-primary)' }}>{contactData.address}</p>
              </div>
            </div>

            <div style={{ marginTop: '32px', padding: '24px', background: 'var(--bg-secondary)', borderLeft: '3px solid var(--accent-gold)' }}>
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>Interested in joining our team?</p>
              <a href={`mailto:${contactData.careersEmail}`} className="body-regular" style={{ color: 'var(--interactive-base)', textDecoration: 'none', display: 'inline-block', marginTop: '8px' }}>{contactData.careersEmail}</a>
            </div>
          </div>

          <div>
            <iframe
              src={contactData.mapEmbedUrl}
              width="100%"
              height="500"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="YFT Group Location"
            />
          </div>
        </div>
      </div>
    </section>
  );
};